<script>
  import Form from "$lib/components/Form/Form.svelte";

  export let placeholder;
  export let formFieldName;
  export let handleClear;

  const searchFormFields = [
    {
      fieldType: "textInputField",
      fieldProps: {
        type: "search",
        name: `${formFieldName}-searchBar`,
        id: `${formFieldName}-searchBar`,
        label: placeholder,
        class: " font-bold bold-text",
        required: false,
        handleClear
      }
    }
  ];
</script>

<Form
  on:submit
  formFields={[{ orientation: "vertical", fields: searchFormFields }]}
  buttonText={"Search"}
  uniqueId={`${formFieldName}-searchBtn`}
/>
